export const moduleName = 'authModule';
